import axios from "axios"

import { backendURL } from "../config"

export const sendFormContents = async (emailObject) => {
    await axios.post(`${backendURL}/email`, emailObject)
}
